// extracted by mini-css-extract-plugin
export var actionIcon = "title-formation-module--actionIcon--80683";
export var actionItem = "title-formation-module--actionItem--5e102";
export var actionItemLink = "title-formation-module--actionItemLink--9c50c";
export var actionNoLink = "title-formation-module--actionNoLink--167bc";
export var actionRoot = "title-formation-module--actionRoot--9ccb3";
export var dividerContent = "title-formation-module--dividerContent--af634";
export var dividerContentItem = "title-formation-module--dividerContentItem--d2acf";
export var horizontalBar = "title-formation-module--horizontalBar--4ec33";
export var labelContent = "title-formation-module--labelContent--5f8fc";
export var noIcon = "title-formation-module--noIcon--3795b";
export var rootTitle = "title-formation-module--rootTitle--4cc49";
export var subtitle = "title-formation-module--subtitle--0943d";
export var subtitleContent = "title-formation-module--subtitleContent--3cfbb";
export var title = "title-formation-module--title--2a022";